import { paymentStats } from "@/mocks/admin/payments";

const trendArrow: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-emerald-600 bg-emerald-50" },
  down: { icon: "ri-arrow-down-line", cls: "text-emerald-600 bg-emerald-50" },
  flat: { icon: "ri-subtract-line", cls: "text-ink-500 bg-cream-100" },
};

// Tiny inline sparkline data — synthesized per metric for visual richness
const sparks: Record<string, number[]> = {
  "Revenue This Month": [62, 78, 70, 84, 92, 88, 96, 102, 98, 110, 124, 132],
  Outstanding: [42, 48, 38, 52, 46, 50, 44, 38, 36, 32, 28, 24],
  "Processed Today": [12, 18, 22, 28, 36, 42, 38, 44],
  "Refund Rate": [2.4, 2.2, 2.0, 1.8, 2.0, 1.6, 1.4, 1.5, 1.3, 1.2, 1.0, 1.2],
};

export default function PaymentsKpis() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
      {paymentStats.map((s) => {
        const arrow = trendArrow[s.trend] || trendArrow.flat;
        const spark = sparks[s.label] || [];
        return (
          <div
            key={s.label}
            className="bg-white border border-ink-100 rounded-lg p-5 flex flex-col"
          >
            <div className="flex items-start justify-between mb-3">
              <div
                className={`w-10 h-10 rounded-md flex items-center justify-center ${s.color}`}
              >
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <span
                className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-1 rounded-full ${arrow.cls}`}
              >
                <i className={arrow.icon}></i>
                {s.trend === "flat" ? "Stable" : "Trend"}
              </span>
            </div>
            <div className="text-[11px] uppercase tracking-wider text-ink-500 font-bold">
              {s.label}
            </div>
            <div className="font-display text-2xl font-bold text-ink-900 mt-1 tabular-nums leading-tight">
              {s.value}
            </div>
            <div className="text-[11px] text-ink-500 mt-1">{s.sub}</div>
            <Spark data={spark} />
          </div>
        );
      })}
    </div>
  );
}

function Spark({ data }: { data: number[] }) {
  if (data.length === 0) return null;
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const W = 100;
  const H = 28;
  const step = W / (data.length - 1);
  const points = data
    .map((v, i) => {
      const x = i * step;
      const y = H - ((v - min) / range) * H;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
  const lastY = H - ((data[data.length - 1] - min) / range) * H;
  return (
    <div className="mt-3 h-7 w-full">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full overflow-visible">
        <polyline
          points={points}
          fill="none"
          stroke="#334155"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.55"
        />
        <circle cx={W} cy={lastY} r="2" fill="#F97316" />
      </svg>
    </div>
  );
}